module.exports = __webpack_public_path__ + "static/img/mutant.44195c4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/mintWalks/mutant.gif
// module id = z/Ev
// module chunks = 1